import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type LabelPropsType<T extends FieldValues> = {
  fieldName: Path<T>;
};

export const Label = <T extends FieldValues>({
  fieldName,
}: LabelPropsType<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <TextField<T>
      fieldName={fieldName}
      label={t('REPORTS.RECIPIENT_GROUPS.LABEL')}
      placeholder={t('REPORTS.RECIPIENT_GROUPS.LABEL_PLACEHOLDER')}
    />
  );
};
